// resolution-grade.js
import products from './products.js';
import Logger from './logger.js';

class ResolutionGrade {

    static async getGrade(imageResolution, size, presentation, orientation, cropBox = null, paper = null) {
        const dpiThresholds = await products.getDPI(paper);
        if (!dpiThresholds) {
            Logger.error('DPI settings not found, fail.');
            return null;
        }

        const productResolution = await products.getSizeResolution(size, presentation, orientation, paper);
        const [mmW, mmH] = productResolution;
        // const targetWpx = mmW / 25.4;
        // const targetHpx = mmH / 25.4;
        // const expectedAspect = targetWpx / targetHpx;
        const expectedAspect = mmW / mmH;

        let cropWpx = imageResolution?.width || 0;
        let cropHpx = imageResolution?.height || 0;
        let adjustedCropBox = null;

        if (!cropWpx || !cropHpx) {
            Logger.console('Invalid image resolution: ', `${imageResolution?.width}x${imageResolution?.height}`);
            return null;
        }

        if (cropBox && cropBox.width > 0 && cropBox.height > 0) {
            // adjustedCropBox = ResolutionGrade.adjustCropBoxToAspect(cropBox, expectedAspect);
            adjustedCropBox = ResolutionGrade.adjustCropBoxToSize(cropBox, cropWpx, cropHpx, expectedAspect);
            cropWpx = Math.round(imageResolution.width * adjustedCropBox.width);
            cropHpx = Math.round(imageResolution.height * adjustedCropBox.height);
        }

        const dpi = ResolutionGrade.calculateDPI(cropWpx, cropHpx, mmW, mmH);

        Logger.console("📐 %sx%smm, crop: %sx%spx, DPI min: %f, max: %f, average: %f", mmW, mmH, cropWpx, cropHpx, dpi.min.toFixed(2), dpi.max.toFixed(2), dpi.average.toFixed(2));
        // Logger.debug(`📐 ${ mmW }x${ mmH }mm DPI calc: `, {
        //     imageResolution,
        //     cropBoxOriginal: cropBox,
        //     adjustedCropBox,
        //     cropWpx: cropWpx.toFixed(2),
        //     cropHpx: cropHpx.toFixed(2),
        //     expectedAspect: expectedAspect.toFixed(4),
        //     adjustedAspect: (cropWpx / cropHpx).toFixed(4),
        //     dpi: dpi.toFixed(2)
        // });

        const grade = ResolutionGrade.gradeFromDPI(dpi.min, dpiThresholds);
        return grade;
    }

    static adjustCropBoxToSize(cropBox, orgWpx, orgHpx, expectedAspect) {
        let width = cropBox.width;
        let height = cropBox.height;
        const currentAspect = (orgWpx * width) / (orgHpx * height);

        if (Math.abs(currentAspect - expectedAspect) < 0.001) {
            return { width, height };
        }

        if (currentAspect < expectedAspect) {
            // Need to increase width
            const newWidth = (height * orgHpx * expectedAspect) / orgWpx;
            if (newWidth > 1) {
                width = 1;
                height = (width * orgWpx) / (orgHpx * expectedAspect);
            } else {
                width = newWidth;
            }
        } else {
            // Need to increase height
            const newHeight = (width * orgWpx) / (orgHpx * expectedAspect);
            if (newHeight > 1) {
                height = 1;
                width = (height * orgHpx * expectedAspect) / orgWpx;
            } else {
                height = newHeight;
            }
        }

        return { width, height };
    }
    // static adjustCropBoxToAspect(cropBox, targetAspect) {
    //     let width = cropBox.width;
    //     let height = cropBox.height;
    //     const currentAspect = width / height;

    //     if (Math.abs(currentAspect - targetAspect) < 0.001) {
    //         return { width, height };
    //     }

    //     if (currentAspect < targetAspect) {
    //         width = height * targetAspect;
    //         if (width > 1) {
    //             width = 1;
    //             height = width / targetAspect;
    //         }
    //     } else {
    //         height = width / targetAspect;
    //         if (height > 1) {
    //             height = 1;
    //             width = height * targetAspect;
    //         }
    //     }

    //     return { width, height };
    // }

    static calculateDPI(cropWpx, cropHpx, mmW, mmH) {
        const ppiW = cropWpx / (mmW / 25.4);
        const ppiH = cropHpx / (mmH / 25.4);
        return {
            min: Math.min(ppiW, ppiH),
            max: Math.max(ppiW, ppiH),
            average: (ppiW + ppiH) / 2
        };
    }

    static gradeFromDPI(dpi, thresholds) {
        const entries = Object.entries(thresholds)
            .filter(([key]) => key.startsWith('grade_'))
            .map(([key, value]) => [parseInt(key.split('_')[1]), value])
            .sort((a, b) => b[0] - a[0]); // sort descending

        for (const [grade, minDpi] of entries) {
            if (dpi >= minDpi) return grade;
        }
        return 1; // default to grade 1 if no thresholds match
    }
}

const grade = {
    get: ResolutionGrade.getGrade
};

export default grade;